import React from "react";

function Footer() {
  return (
    <div className="flex flex-col items-center">
      <p className="pt-2 text-sm text-center text-pretty">
        © 2024 Consulenza Successoria - Avv. Valentina Mango - P.I. 48592948079
        | Privacy Policy - Cookie Policy
      </p>
      <p className="pt-2 pb-2 text-xs">Powered by Tec2077</p>
    </div>
  );
}

export default Footer;
